import withResponsive from '../hoc/withResponsive'
import onResize from '../utils/onResize'
import SwiperCore, { Pagination } from 'swiper/core'
import 'swiper/swiper-bundle.css'

SwiperCore.use([Pagination])

export default withResponsive({
  name: 'navigation-slider',

  indexLevel: null,
  indexContent: null,
  indexSubContent: null,

  ui: {
    'btNavigation[]': '[js-navigation-target]',
  },

  events: [
    {
      target: 'btNavigation',
      on: 'click',
      handle (e) {
        e.preventDefault()
        const targetAttr = e.currentTarget.getAttribute('js-navigation-target')
        const targetLevels = targetAttr.split('-')
        const indexLevel = targetLevels[0]
        const indexContent = targetLevels[1]
        const indexSubContent = targetLevels[2]
        const targetSlide = this.slider.slides[indexLevel]

        if (indexContent && this.indexContent !== indexContent) {
          this.indexContent = indexContent
          this.displayTarget(targetSlide, targetSlide.querySelector(`[js-navigation-target-name="${targetAttr}"]`))
        }

        if (indexSubContent && this.indexSubContent !== indexSubContent) {
          this.indexSubContent = indexSubContent
          this.displayTarget(targetSlide, targetSlide.querySelector(`[js-navigation-target-name="${targetAttr}"]`))
          const targetTitle = document.querySelector(`[js-navigation-target-name="${+indexLevel - 1}-${indexContent}"]`).querySelector('.small-title').innerText
          targetSlide.querySelector('.bt-back-title').innerText = targetTitle
        }

        if (this.indexLevel !== indexLevel) {
          this.slider.slideTo(indexLevel)
          // then this.indexLevel is updated by swiper activeIndexChange()
        }
      },
    },
  ],

  displayTarget (contentWrapper, target) {
    contentWrapper.querySelectorAll('[js-navigation-target-name]').forEach(el => {
      if (el === target) {
        el.classList.add('is-active')
      } else {
        el.classList.remove('is-active')
      }
    })
  },

  componentDidMount () {
    this.off = onResize(this.onResize.bind(this))

    this.slider = new SwiperCore(this.el, {
      allowTouchMove: false,
      autoHeight: true,
      on: {
        activeIndexChange: (swiper) => {
          this.indexLevel = swiper.activeIndex
          if (this.indexLevel === 0) {
            this.indexContent = this.indexSubContent = null
          }
        },
      },
    })
  },

  componentWillUnmount () {
    this.off()

    this.slider.destroy()
    this.ui.pagination.innerHTML = ''
  },

  onResize () {
    if (this.slider && this.slider.slides !== undefined) {
      setTimeout(() => {
        this.checkDisable()
      }, 500)
    }
  },

  checkDisable () {
    /* if (this.slider.slides !== 'undefined') {
      const nbSlides = this.slider.slides.length

      if (window.innerWidth < 768 && nbSlides < 2) {
        this.slider.allowTouchMove = false
        this.ui.pagination.classList.add('is-hidden')
      } else {
        this.slider.allowTouchMove = true
        this.ui.pagination.classList.remove('is-hidden')
      }

      Object.entries(this.props.options.breakpoints).forEach((breakpoint) => {
        if (
          window.innerWidth >= breakpoint[0] &&
          nbSlides / breakpoint[1].slidesPerView <= 1
        ) {
          this.slider.allowTouchMove = false
          this.ui.pagination.classList.add('is-hidden')
        } else {
          this.slider.allowTouchMove = true
          this.ui.pagination.classList.remove('is-hidden')
        }
      })
    } */
  },
})
